module.exports = __webpack_public_path__ + "static/media/waimea.5c2150c5.jpeg";